import { Trans } from '@lingui/macro';
import { Box, MenuItem } from '@material-ui/core';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import FormSection from '../../form/FormSection';
import { NgpLabelValue } from '../../form/NgpLabelValue';
import NgpSelect from '../../form/NgpSelect';
import {
    CALL_DURATION_OPTIONS,
    DEFAULT_DURATION,
    DEFAULT_RING_DURATION,
    JITTER_OPTIONS,
    SCHEDULED_CALL_DURATION_OPTIONS,
    SCHEDULED_RING_DURATION_OPTIONS,
} from './VoipTestConstants';
import { durationDisplayDefault } from './VoipPulseTestConfigHelpers';

export const readOnlyTopMargin = 1.5;

export const useSettingStyles = makeStyles(() => ({
    testSelect: {
        marginRight: '8px',

        '& .MuiSelect-select': {
            minWidth: 390,
        },
    },
}));

function CallerDetailsSection({ config }) {
    return (
        <FormSection title={<Trans>Caller nPoint Configuration</Trans>}>
            {config.caller.agent.voipConfiguration?.primaryCallManager?.name && (
                <Box mt={readOnlyTopMargin}>
                    <NgpLabelValue
                        dataLabel={'Call Manager'}
                        dataValue={_.get(config, 'caller.agent.voipConfiguration.primaryCallManager.name')}
                        showIfEmpty
                    />
                </Box>
            )}
            {config.caller.agent.voipConfiguration?.phoneNumber && (
                <Box mt={readOnlyTopMargin}>
                    <NgpLabelValue
                        dataLabel={'Phone Number'}
                        dataValue={_.get(config, 'caller.agent.voipConfiguration.phoneNumber')}
                        showIfEmpty
                    />
                </Box>
            )}
            {config.caller.agent.voipConfiguration?.extension && (
                <Box mt={readOnlyTopMargin}>
                    <NgpLabelValue
                        dataLabel={'Extension'}
                        dataValue={_.get(config, 'caller.agent.voipConfiguration.extension')}
                        showIfEmpty
                    />
                </Box>
            )}
        </FormSection>
    );
}

function CalleeDetailsSection({ config }) {
    return (
        <FormSection title={<Trans>Callee nPoint Configuration</Trans>}>
            {config.callee.agent.voipConfiguration?.primaryCallManager?.name && (
                <Box mt={readOnlyTopMargin}>
                    <NgpLabelValue
                        dataLabel={'Call Manager'}
                        dataValue={_.get(config, 'callee.agent.voipConfiguration.primaryCallManager.name')}
                        showIfEmpty
                    />
                </Box>
            )}
            {config.callee.agent.voipConfiguration?.phoneNumber && (
                <Box mt={readOnlyTopMargin}>
                    <NgpLabelValue
                        dataLabel={'Phone Number'}
                        dataValue={_.get(config, 'callee.agent.voipConfiguration.phoneNumber')}
                        showIfEmpty
                    />
                </Box>
            )}
            {config.callee.agent.voipConfiguration?.extension && (
                <Box mt={readOnlyTopMargin}>
                    <NgpLabelValue
                        dataLabel={'Extension'}
                        dataValue={_.get(config, 'callee.agent.voipConfiguration.extension')}
                        showIfEmpty
                    />
                </Box>
            )}
        </FormSection>
    );
}

export function VoipTestNowCallSettings({ config, testNow, codecs }) {
    const classes = useSettingStyles();

    return (
        <FormSection title={<Trans>Call Settings</Trans>}>
            {(config.caller?.showDetails || config.caller?.agent?.voipConfiguration?.useDirectCalling) && (
                <CallerDetailsSection config={config} />
            )}
            {(config.callee?.showDetails || config.callee?.agent?.voipConfiguration?.useDirectCalling) && (
                <CalleeDetailsSection config={config} />
            )}
            <NgpSelect
                fieldName="testConfig.ringDuration"
                label={<Trans>Ring Duration</Trans>}
                required
                className={classes.testSelect}
            >
                {SCHEDULED_RING_DURATION_OPTIONS.map((ringDuration) => (
                    <MenuItem key={ringDuration} value={ringDuration}>
                        {durationDisplayDefault(ringDuration, DEFAULT_RING_DURATION)}
                    </MenuItem>
                ))}
            </NgpSelect>
            {testNow && (
                <NgpSelect
                    fieldName="testConfig.duration"
                    label={<Trans>Call Duration</Trans>}
                    required
                    className={classes.testSelect}
                >
                    {CALL_DURATION_OPTIONS.map((duration) => (
                        <MenuItem key={duration} value={duration}>
                            {durationDisplayDefault(duration, DEFAULT_DURATION)}
                        </MenuItem>
                    ))}
                </NgpSelect>
            )}
            {!testNow && (
                <NgpSelect
                    fieldName="testConfig.duration"
                    label={<Trans>Duration</Trans>}
                    required
                    className={classes.testSelect}
                >
                    {SCHEDULED_CALL_DURATION_OPTIONS.map((duration) => (
                        <MenuItem key={duration} value={duration}>
                            {durationDisplayDefault(duration, DEFAULT_DURATION)}
                        </MenuItem>
                    ))}
                </NgpSelect>
            )}
            {testNow && (
                <NgpSelect
                    fieldName="testConfig.jitter"
                    label={<Trans>Jitter Buffer Size</Trans>}
                    required
                    className={classes.testSelect}
                >
                    {JITTER_OPTIONS.map((jitter) => (
                        <MenuItem key={jitter} value={jitter}>
                            {jitter}ms
                        </MenuItem>
                    ))}
                </NgpSelect>
            )}
            <NgpSelect
                fieldName="testConfig.preferredCodec"
                label={<Trans>Preferred Codec</Trans>}
                required
                className={classes.testSelect}
            >
                {_.map(codecs, (value, key) => (
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                ))}
            </NgpSelect>
        </FormSection>
    );
}
